


//Map of special field names that need custom formatting

const FIELD_NAME_OVERRIDES: Record<string, string> = {
  FFSResult: 'FFS Result',
  FFSPerformed: 'FFS Performed',
  AdditionalInformationForEquipmentEN: 'Additional Information For Equipment EN',
  AdditionalInformationForEquipmentRU: 'Additional Information For Equipment RU',
  AdditionalInformationForEquipmentKZ: 'Additional Information For Equipment KZ',
  CurrentFDMStatus: 'Current FDM Status',
  // Add more custom mappings here as needed
};

export function formatFieldName(fieldName: string): string {
  if (!fieldName) return '';

  // Check for custom overrides first
  if (FIELD_NAME_OVERRIDES[fieldName]) {
    return FIELD_NAME_OVERRIDES[fieldName];
  }

  // Add space before capital letters (except the first one)
  return fieldName.replace(/([A-Z])/g, ' $1').trim();
}


export function formatFieldNames(fieldNames: string[]): Array<{ value: string; label: string }> {
  return fieldNames.map(field => ({
    value: field,
    label: formatFieldName(field)
  }));
}
